export const NumberToCurrency = (num: number): string => {
    return num.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
}

export const ShowAsPhoneNumber = (phone: string): string => {
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

export const PhoneNumberToString = (phone: string): string => {
    if(!phone) {
        return '';
    }
    return phone.replace(/\D/g, '');
}